import React from "react";
import { Row, Col } from "antd";
import InputComponent from "./InputComponent";
import { PercentageWrapper, ErrMargin } from "../styles";
import validate from "../../../../../utils/validations";
import regexMap from "../../../../../utils/regexMap";

export default class PercentInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            percentage: {
                value: props.percentage || "",
                touched: false,
                valid: '',
                matchPattern: regexMap.percent,
                validationRules: {
                    isRequired: true,
                    isValidPercent: true
                },
                messages: {
                    isRequired: 'Please enter percentage',
                    isValidPercent: 'Please enter a valid percentage'
                }
            },
        };
    }

    componentWillMount() {
        if(this.props.validateForm){
            this.runFormValidation();
        }
    }
    
    componentDidMount() {
        this.handleFormChange();
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({
            percentage: {
                value: nextProps.percentage || "",
                touched: false,
                valid: '',
                matchPattern: regexMap.percent,
                validationRules: {
                    isRequired: true,
                    isValidPercent: true
                },
                messages: {
                    isRequired: 'Please enter percentage',
                    isValidPercent: 'Please enter a valid percentage'
                }
            },
        })
        if(nextProps.validateForm){
            this.runFormValidation();
        }
    }
    
    runFormValidation = () => {
        const updatedFormElement = {
            ...this.state
        };
        for (const inputIdentifier of Object.keys(updatedFormElement)) {
            if (updatedFormElement[inputIdentifier].validationRules 
                && Object.keys(updatedFormElement[inputIdentifier].validationRules).length) {
                    updatedFormElement[inputIdentifier].valid = validate(updatedFormElement[inputIdentifier].value, updatedFormElement[inputIdentifier].validationRules);
                    updatedFormElement[inputIdentifier].touched = true;
                }
        }
        this.setState({
            ...updatedFormElement
        });
    }
    
    handleBlur = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        const updatedFormElement = {
            ...this.state[name]
        };

        updatedFormElement.valid = validate(value, updatedFormElement.validationRules);

        updatedFormElement.touched = true;
        
        this.setState({
            [name]: updatedFormElement
        });
    };

    handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;   
        const updatedFormElement = {
            ...this.state[name]
        };
        
        const matched = updatedFormElement.matchPattern ? updatedFormElement.matchPattern.test(value) : true;
        if (matched) {
            updatedFormElement.value = value;
            updatedFormElement.touched = true;
            updatedFormElement.validate = "";
            this.setState({
                [name]: updatedFormElement
            }, this.handleFormChange);
        }
    };

    checkFormValid = (state) => {
        let formIsValid = true;
        for (let inputIdentifier of Object.keys(state)) {
            if (state[inputIdentifier].validationRules 
                && Object.keys(state[inputIdentifier].validationRules).length) {
                    formIsValid = !validate(state[inputIdentifier].value, state[inputIdentifier].validationRules) && formIsValid;
                }
        }
        return formIsValid;
    }

    handleFormChange = () => {
        this.props.manipulateAllFormsValid();
        this.props.handleFormChange(this.formatData());
    }

    // format data before passing it back
    formatData = () => {
        return {
            percentage: this.state.percentage.value,
            isFormValid: this.checkFormValid(this.state)
        };
    }

    showError = (elem) => {
        return elem.touched && elem.valid;
    }

    render() {
        const { percentage } = this.state;

        return (
            <div>
            <PercentageWrapper>
                <Row>
                    <Col lg={{ span: 10, offset: 0 }} md={{ span: 10 }}>
                        <InputComponent
                            name="percentage"
                            id={this.props.id}
                            handleBlur={this.handleBlur}
                            title={this.props.title}
                            hoverTitle="Percentages must be entered in whole numbers"
                            placeholder="Enter percentage"
                            arialabel="Enter percentage"
                            handleInputChange={this.handleChange}
                            value={percentage.value}
                        />
                        {this.showError(percentage)
                            ? <ErrMargin>{percentage.messages[percentage.valid]}</ErrMargin>
                            : null}
                    </Col>
                </Row>
            </PercentageWrapper>
            </div>
        );
    }
}
